import React from 'react'
import { Table, Text } from '@mantine/core'
import { CompanyItem } from './types'
import { useTheme } from '../../../components/ThemeProvider'

interface CompanySummaryProps {
  companies: CompanyItem[]
}

const CompanySummary: React.FC<CompanySummaryProps> = ({ companies }) => {
  const theme = useTheme()
  const totalCount = companies.length
  const activeCount = companies.filter((c) => c.basicInfo.regStatus === '存续').length
  const relationshipTypes = Array.from(new Set(companies.flatMap((c) => c.relationship))).length
  const regions = Array.from(new Set(companies.map((c) => c.basicInfo.base).filter(Boolean))).length

  const dishonestyCases = companies.reduce((sum, c) => sum + (c.dishonestExecutedPerson?.length || 0), 0)
  const enforcementCases = companies.reduce((sum, c) => sum + (c.executedPerson?.length || 0), 0)
  const penalties = companies.reduce((sum, c) => sum + (c.adminPenalty?.length || 0), 0)

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        关联企业概览
      </Text>
      <Table
        highlightOnHover
        withColumnBorders={false}
        verticalSpacing="sm"
        className="mt-3"
        styles={{
          th: {
            backgroundColor: theme.surfaceMutedColor,
            color: theme.accentTextColor,
          },
          table: {
            fontSize: '13px',
          },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>指标</Table.Th>
            <Table.Th>数值</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>关联企业总数</Table.Td>
            <Table.Td>{totalCount}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>存续企业</Table.Td>
            <Table.Td>{activeCount}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>关联类型数量</Table.Td>
            <Table.Td>{relationshipTypes}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>涉及地区</Table.Td>
            <Table.Td>{regions}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>失信被执行记录</Table.Td>
            <Table.Td>{dishonestyCases}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>执行案件记录</Table.Td>
            <Table.Td>{enforcementCases}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>行政处罚记录</Table.Td>
            <Table.Td>{penalties}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </div>
  )
}

export default CompanySummary
